import { AfterViewInit, Component, OnInit } from '@angular/core';
import { fciWebsiteService } from '../../service/fci-website.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import { HttpEvent, HttpEventType } from '@angular/common/http';
declare let $: any;
declare let Swiper: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';

import { TranslateService } from '@ngx-translate/core';

@Component({ 
  selector: 'app-award-details',
  templateUrl: './award-details.component.html',
  styleUrls: ['./award-details.component.css']
})
export class AwardDetailsComponent implements OnInit, AfterViewInit {

  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private encDec: EncryptDecryptService, private route: Router, public translate: TranslateService) { }

  imageUrl = environment.serviceURL + 'storage/app/uploads/';
  backendUrl = environment.serviceURL;
  backend_url: any = environment.serviceURL;
  processId: any = 0;
  awardList: any[] = [];

  language: any = '';

  ngOnInit(): void {

    this.language = sessionStorage.getItem('locale'); //dynamic content language translation 

    let schemeArr: any = [];
    this.routerparam.paramMap.subscribe((params: ParamMap) => {
      let encSchemeId = params.get('id')
      if (encSchemeId != "") {
        let schemeStr = this.encDec.decText(encSchemeId);
        schemeArr = schemeStr.split(':');
        this.processId = schemeArr[0];
      }
    });
    
    // FOR PHOTO GALLERY AND VIDEO GALLERY - STARTS
    setTimeout(() => {
      $('#award-container').lightGallery();
    }, 2000);


    // FOR CLIENTS LINK CAROUSEL - STARTS
    new Swiper("#awardees-swiper", {
      // Optional parameters
      slidesPerView: 6,
      direction: 'horizontal',
      loop: true,
      // autoplay: true,
      spaceBetween: 10,

      breakpoints: {
        '1440': {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        '1024': {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        '768': {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        '320': {
          slidesPerView: 1,
          spaceBetween: 40,
        },

      },
      // Navigation arrows
      navigation: {
        nextEl: '.award-next',
        prevEl: '.award-prev',
      }
    });
    // FOR CLIENTS LINK CAROUSEL - ENDS

    this.getAwardList();
  }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }
 
  content_apiresponse:any;
  mediaResponse :any;
  galleryImg:any=[];
  hasImages:boolean=false;
  getAwardList() {

    let params = [{
      "secSlNo": 1,
      "offSet": 0,
      "noOfRecords": '',
      "orderBy": [{ "columnName": "intId", "type": "DESC" }],
      "condition": [
        { "columnName": "intId", "operator": "=", "value": this.processId, "joinoperator": "and" },
        { "columnName": "INT_TYPE", "operator": "=", "value": 7, "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" }
      ],
      "viewParameters": ""
    }];
    this.fciwebservice.getAwardEvent(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.mediaResponse = response.result.sec_1;
            this.awardList = this.mediaResponse;
            // console.log(this.awardList);
            if(this.awardList.length > 0){ 
              let imglist = this.awardList[0].otherImages;
              if(this.awardList[0].otherImages.length > 0){
                this.hasImages = true;
                for (let i = 0; i < imglist.length; i++) {
                  if(imglist[i]?.images_details.fileSize!==''){
                    this.galleryImg.push(imglist[i]);
                  }
                }
              }
            }
          } 
      }
    });


  }

  htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }


 


}
